/**
 * @generated SignedSource<<f73b920d3d985eda6bb1d145cb09eae2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ReadNotificationMutationInput = {
  clientMutationId?: string | null;
  id: string;
};
export type NotificationsReadMutation$variables = {
  input: ReadNotificationMutationInput;
};
export type NotificationsReadMutation$data = {
  readonly readNotification: {
    readonly __typename: "ReadNotificationError";
    readonly message: string;
  } | {
    readonly __typename: "ReadNotificationSuccess";
    readonly notification: {
      readonly id: string;
      readonly seen: boolean | null;
    };
    readonly notificationUnreadTotal: {
      readonly count: number;
      readonly id: string;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type NotificationsReadMutation = {
  response: NotificationsReadMutation$data;
  variables: NotificationsReadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "readNotification",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Notification",
            "kind": "LinkedField",
            "name": "notification",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "seen",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationUnreadTotal",
            "kind": "LinkedField",
            "name": "notificationUnreadTotal",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "ReadNotificationSuccess",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "type": "ReadNotificationError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsReadMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationsReadMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d9b2aa4bcc81ed371b3b7dd682ac4bca",
    "id": null,
    "metadata": {},
    "name": "NotificationsReadMutation",
    "operationKind": "mutation",
    "text": "mutation NotificationsReadMutation(\n  $input: ReadNotificationMutationInput!\n) {\n  readNotification(input: $input) {\n    __typename\n    ... on ReadNotificationSuccess {\n      notification {\n        id\n        seen\n      }\n      notificationUnreadTotal {\n        id\n        count\n      }\n    }\n    ... on ReadNotificationError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "36f5c26f859f696c933bfb039347acd5";

export default node;
